// Small, side-effect-free style helpers extracted out of PageRenderer.jsx so
// they can be unit-tested directly -- PageRenderer.jsx itself transitively
// imports "swiper/react" (via swiperPubCategoryProdMatrix.jsx), which Jest
// cannot resolve in this project's test environment, so nothing exported
// from PageRenderer.jsx can be require()'d from a test file today.

// Normalizes whichever of background/backgroundColor a toggle-group's
// active/inactive style authored (PageBuilder's property panel can save
// either, and a gradient can only ever be `background`) down to a SINGLE
// property. Real bug fixed here: the previous version set BOTH
// background+backgroundColor for a solid color but only `background` for a
// gradient -- switching a shop category toggle between an active (often
// gradient) and inactive (often solid) state made backgroundColor
// appear/disappear across renders, which is exactly what React warns about
// ("mix shorthand and non-shorthand properties for the same value").
// `background` alone renders identically for a solid color or a gradient,
// so collapsing to it unconditionally removes the conflict at the source
// without changing anything visually.
export function withToggleBackgroundColor(style = {}) {
  const next = { ...style };
  const background = next.background ?? next.backgroundColor;
  if (background != null) next.background = background;
  delete next.backgroundColor;
  return next;
}
